import styled from 'styled-components';

export const AlertContent = styled.div`
  font-size: 16px;
  line-height: 25px;
`;
